var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('FullWidthImage',{staticStyle:{"height":"500px"},attrs:{"image-link":_vm.imagelink1,"text":"Contact","buttonText":"","overlay":true,"button":false,"blackWhite":false}}),_c('ContactGegevens'),_c('Recenties')],1)}
var staticRenderFns = []

export { render, staticRenderFns }